import { render, staticRenderFns } from "./AddressNormalization.vue?vue&type=template&id=7d83310e"
import script from "./AddressNormalization.vue?vue&type=script&lang=js"
export * from "./AddressNormalization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports